import React, { FC, HTMLProps } from 'react'
import { StyledForm } from './Form.styles'

type FormProps = Omit<HTMLProps<HTMLFormElement>, 'ref' | 'type' | 'as'> & {
  children?: React.ReactNode
}

export const Form: FC<FormProps> = ({ children, ...props }) => (
  <StyledForm {...props}>
    {children}

    {/* Workaround to submit forms by pressing enter and restoring the default form behavior */}
    <input style={{ visibility: 'hidden' }} type='submit' />
  </StyledForm>
)
